import { getButtonTranslations } from '@common/i18n/buttons';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from '@common/i18n/constants';
import type { TemplateFormLanguage } from '@common/types/templateForms';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';

const backButtonStyle = {
    width: '100px',
    height: '50px',
    marginBottom: '10px',
    color: 'white',
    fontSize: 'large',
    border: '2px solid white',
};

const backButtonStyleMobile = {
    width: '100px',
    height: '50px',
    marginBottom: '10px',
    color: 'white',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: '0px',
    textTransform: 'none',
    fontSize: 'large',
    border: '0px',
};

interface Props {
    onClick(): void;
    language?: TemplateFormLanguage;
}

export default function BackButton({ onClick, language = DEFAULT_TEMPLATE_FORM_LANGUAGE }: Props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const t = getButtonTranslations(language);

    return (
        <Box>
            <Button onClick={onClick} sx={isMobile ? backButtonStyleMobile : backButtonStyle}>
                {isMobile && <ArrowBackIosRoundedIcon sx={{ marginRight: '5px' }} />}
                {t.back}
            </Button>
        </Box>
    );
}
